module.exports = __webpack_public_path__ + "media/application/images/icons/n-a-bb7bb95139a72ff5404e985c5eb5175d.svg";